import React from "react";

import {usePlanner} from "../../../../components/Planner";
import Timeline from "../../../../components/Planner/Timeline";
import ArtificialIntelligenceIcon from "../ArtificialIntelligenceIcon";
import RatesToolbar from "./RatesToolbar";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";


const DesktopPlanner = (props) => {
    const {
        ratesViewMode,
        onChangeRatesViewMode,
        onClickMassEdit,
        onPriceEdit,
        formConfigurator,
        baseRate,
    } = props;

    const {minDate, maxDate, initialDate, goToDate, selectedRange, handleClickOutside} = usePlanner();

    const rateId = baseRate?.id;  // TODO allow to select another rate other than the base rate

    const showEditButton = selectedRange.from && selectedRange.to && selectedRange.resource;

    return <Stack spacing={4} alignItems="center" onClick={handleClickOutside} pb={30} pt={3}>
        <RatesToolbar minDate={minDate}
                      maxDate={maxDate}
                      initialDate={initialDate}
                      selectedRatesViewMode={ratesViewMode}
                      onChangeRatesViewMode={onChangeRatesViewMode}
                      onSelectMonth={goToDate}
                      onClickMassEdit={onClickMassEdit}
                      rateId={rateId}
        />
        {
            showEditButton ?
                <Button startIcon={<EditIcon/>}
                        variant="outlined"
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            onPriceEdit(selectedRange.from, selectedRange.to, selectedRange.resource);
                        }}
                        sx={{minWidth: "200px", m: 0}}>
                    Modifica prezzi
                </Button>
                :
                <Button startIcon={<ArtificialIntelligenceIcon simplified/>}
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            formConfigurator.open()
                        }}
                        sx={{minWidth: "200px", m: 0}}>
                    Configura prezzi
                </Button>
        }

        <Timeline dayCellWidth={52}/>

    </Stack>
}

export default DesktopPlanner;